import React from 'react';
import { connect } from 'react-redux';
import { getApiStatus } from '../../../Reducers/ApiStatusReducer';
import { getReportStats, getReportColumns as _getReportColumns } from '../../../Reducers/ReportPortalReducer';
import * as ReportPortalActions from '../../../Actions/ReportPortalActions';
import RecruiterReports from '../../../Components/ReportPortal/ReportStatsTab/RecruiterReports/RecruiterReports';

const mapStateToProps = state => {
  return {
    fetchReportStatsApiStatus: getApiStatus(state, 'fetchReportStatsApiStatus'),
    exportReportApiStatus: getApiStatus(state, 'exportReportApiStatus'),
    reportStats: getReportStats(state, 'recruiters'),
    reportColumns: _getReportColumns(state, 'recruiters'),
  };
};

const mapDispatchToProps = {
  fetchReportStats: ReportPortalActions.getReportStats,
  generateReport: ReportPortalActions.generateReport,
  clearReportStats: ReportPortalActions.clearReportStats,
  getReportColumns: ReportPortalActions.getReportColumns,
  clearFetchReportStatsApiStatus: ReportPortalActions.clearFetchReportStatsApiStatus,
  clearRecruitersForDropdownLists: ReportPortalActions.clearRecruitersForDropdownLists,
  clearClientsForDropdownLists: ReportPortalActions.clearClientsForDropdownLists,
};

export function RecruiterReportsContainer(props) {
  const {
    reportStats,
    fetchReportStats,
    fetchReportStatsApiStatus,
    clearReportStats,
    generateReport,
    exportReportApiStatus,
    clearFetchReportStatsApiStatus,
    savedQueryConfig,
    onSaveQuerySuccess,
    clearRecruitersForDropdownLists,
    clearClientsForDropdownLists,
  } = props;

  return (
    <div>
      <RecruiterReports
        savedQueryConfig={savedQueryConfig}
        onSaveQuerySuccess={onSaveQuerySuccess}
        fetchReportStatsApiStatus={fetchReportStatsApiStatus}
        reportStats={reportStats}
        getReportStats={fetchReportStats}
        clearReportStats={clearReportStats}
        exportReportApiStatus={exportReportApiStatus}
        generateReport={generateReport}
        clearFetchReportStatsApiStatus={clearFetchReportStatsApiStatus}
        clearRecruitersForDropdownLists={clearRecruitersForDropdownLists}
        clearClientsForDropdownLists={clearClientsForDropdownLists}
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RecruiterReportsContainer);
